export default __webpack_public_path__ + "static/media/Schaltschrank_Fla╠êchen.ae4bce54.png";